<script lang="ts">
	// import {
	// 	PUBLIC_ENABLE_DYNAMIC_IMAGE_RESIZE,
	// 	PUBLIC_ENABLE_STATIC_IMAGE_RESIZE,
	// 	PUBLIC_ASSETS_PREFIX,
	// 	PUBLIC_APEX_SUBDOMAIN
	// } from '$env/static/public';
	import { client_config } from '$lib/client_config';

	export let src: string,
		alt: string,
		imageSourceType: 'internal' | 'external' = 'internal',
		classes: { container?: string; image?: string } = { container: '', image: '' };

	let imageElement: HTMLImageElement;
	const loadImage = (element: HTMLImageElement) => {
		const image = new Image();
		image.srcset = getSrcset(imageSourceType);
		// console.log('image.srcset', image.srcset);
		image.onload = () => {
			element.srcset = image.srcset;
			element.classList.remove('hidden');
			imageLoaded = true;
		};
		image.onerror = () => {
			console.error('error while loading image with src:', src);
			element.srcset = '/placeholder.webp';
			element.classList.remove('hidden');
			imageLoaded = true;
		};
	};

	$: imageLoaded = false;

	const getSrcset = (imageSourceType: string) => {
		let srcset = src;
		let sizes = [400, 600, 900, 1200, 1600, 2000];
		let paths = [];

		if (imageSourceType === 'external') {
			if (
				client_config.env_config.enable_dynamic_image_resize &&
				client_config.env_config.enable_dynamic_image_resize === 'yes'
			) {
				for (const size of sizes) {
					paths.push(
						`${client_config.env_config.assets_prefix}/cdn-cgi/image/width=${size},f=auto,quality=60/${src} ${size}w`
					);
				}
				srcset = paths.join(', ');
			} else {
				srcset = `${client_config.env_config.assets_prefix}/${src}`;
			}
		} else {
			if (
				client_config.env_config.enable_static_image_resize &&
				client_config.env_config.enable_static_image_resize === 'yes'
			) {
				if (client_config.env_config.apex_subdomain) {
					let srcSplitArray = src.split('/_app');
					srcSplitArray[0] = client_config.env_config.apex_subdomain;
					src = srcSplitArray.join('/_app');
					for (const size of sizes) {
						paths.push(
							`${client_config.env_config.apex_subdomain}/cdn-cgi/image/width=${size},f=auto,quality=60/${src} ${size}w`
						);
					}
				} else {
					for (const size of sizes) {
						paths.push(`/cdn-cgi/image/width=${size},f=auto,quality=60/${src} ${size}w`);
					}
				}
				srcset = paths.join(', ');
			}
		}
		return srcset;
	};
</script>

<div class="relative {classes.container || ''}">
	<img
		use:loadImage
		bind:this={imageElement}
		srcset="/placeholder.webp"
		{alt}
		class="w-full {classes.image || ''}"
		on:error={() => {
			imageLoaded = true;
			imageElement.srcset = '/placeholder.webp';
		}}
	/>
	{#if !imageLoaded}
		<div class="shimmer absolute inset-0 h-full w-full"></div>
	{/if}
</div>

<style>
	.shimmer {
		opacity: 0.7;
		animation: shimmer-effect 800ms linear infinite alternate;
	}

	@keyframes shimmer-effect {
		0% {
			background-color: hsl(200, 20%, 70%);
		}
		100% {
			background-color: hsl(200, 20%, 95%);
		}
	}

	@keyframes fade-in {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 1;
		}
	}

	.fade-in {
		animation: 1s fade-in ease-in;
	}
</style>
